module.exports = __webpack_public_path__ + "img/62-716e23.png";